// RedirectHandler.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

const RedirectHandler = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/login' && location.pathname !== '/home') {
      localStorage.setItem('redirectUri', location.pathname);
    }
    if(location.pathname.includes('/notification')){
      localStorage.setItem('setting','notification');
    }
    if(location.pathname.includes('/user')){
      localStorage.setItem('setting','user');
    }
  }, [location]);

  return <>{children}</>;
};

RedirectHandler.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RedirectHandler;